import DocumentActionTypes from "../../actions/document/types";

export default (claimsSearchResults = null, action) => {
  switch (action.type) {
    case DocumentActionTypes.SEARCH_CLAIMS:
      return action.payload;
    case DocumentActionTypes.RESET_SEARCH_CLAIMS_RESULTS:
      return null;
    default:
      return claimsSearchResults;
  }
};
